// extracted by mini-css-extract-plugin
module.exports = {"group":"ScrollDownButton_group__BXnmp","ScrollDownButton":"ScrollDownButton_ScrollDownButton__UOi4Y","dot":"ScrollDownButton_dot__R_p_r","text":"ScrollDownButton_text__bQoaS"};